import React, { useEffect } from 'react';
import { Checkbox } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'services/types';

import {
    addSelectedTableRow as addSelectedPerson,
    removeSelectedTableRow as removeSelectedPerson
    // @ts-ignore
} from 'services/selectedTableCells/actions';
import {
    makeSelectIsRowSelected,
    makeSelectAreSomeRowsSelected
    // @ts-ignore
} from 'services/selectedTableCells/selectors';

export interface Props {
    rowId: number | number[];
}

export default function PeopleTableCheckbox(props: Props): React.ReactElement {
    const { rowId } = props;
    const dispatch = useDispatch();

    const checked = useSelector((state: AppState) =>
        makeSelectIsRowSelected()(state, { rowId })
    );

    const indeterminate = useSelector((state: AppState) =>
        makeSelectAreSomeRowsSelected()(state, { rowId })
    );

    const handleClick = (event: React.MouseEvent<HTMLInputElement>): void => {
        event.stopPropagation();
        if (checked || indeterminate) {
            dispatch(removeSelectedPerson(rowId));
        } else {
            dispatch(addSelectedPerson(rowId));
        }
    };

    useEffect(() => {
        return (): void => {
            dispatch(removeSelectedPerson(rowId));
        };
    }, [dispatch, rowId]);

    return (
        <Checkbox
            onClick={handleClick}
            checked={checked}
            indeterminate={!checked && indeterminate}
        />
    );
}
